// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"0e0637b1","234":"c67cdb18"}[chunkId] + ".chunk.js";
};